export const STORAGE_KEY = 'lifeos.v1';
export const UNASSIGNED_STORE = 'Unassigned';
export const CHORE_CADENCES = ['Daily', 'Weekly', 'Monthly', 'Quarterly', 'Seasonal', 'As Needed'];
export const SCHEDULED_CHORE_CADENCES = CHORE_CADENCES.filter((c) => c !== 'Daily');
export const WEEK_DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
export const TRANSACTION_TYPES = ['Fixed', 'Variable'];
export const MONTH_NAMES = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export const LEGACY_DEMO_CHORES = new Set([
  'Reset kitchen counters',
  'Laundry catch-up',
  'Replace HVAC filter',
  'Rotate seasonal closet'
]);

export const MORNING_REFLECTIONS = [
  { key: 'identity', label: 'Identity reminder', prompt: 'What proof exists that I have already transformed?' },
  { key: 'future', label: 'Future connection', prompt: 'What future am I organizing today around?' },
  { key: 'eliminate', label: 'Elimination filter', prompt: 'What does not deserve attention today?' },
  { key: 'action', label: 'One high-leverage action', prompt: 'What single action creates disproportionate momentum?' }
];

export const EVENING_REFLECTIONS = [
  { key: 'gain', label: 'Gain recognition', prompt: 'What progress happened today?' },
  { key: 'evidence', label: 'Identity evidence', prompt: 'What proved alignment today?' },
  { key: 'drift', label: 'Friction + drift', prompt: 'Where did attention drift without judgment?' },
  { key: 'tomorrow', label: 'Future reinforcement', prompt: 'What deserves focus next?' }
];

export const BUDGET_ROWS = [
  ['April 2026', 'Income', 'Income', 1200, 1380.40, 'Fixed', '2026-04-24'],
  ['April 2026', 'Bills', 'Subscriptions', 60, 63.60, 'Fixed', '2026-04-02'],
  ['April 2026', 'Bills', 'Cell Phone / Internet', 30, 30, 'Fixed', '2026-04-20'],
  ['April 2026', 'Bills', 'Insurance', 42, 0, 'Fixed', '2026-04-03'],
  ['April 2026', 'Utilities', 'Electric', 150, 134.61, 'Variable', '2026-04-15'],
  ['April 2026', 'Utilities', 'Gas', 150, 346.78, 'Variable', '2026-04-15'],
  ['April 2026', 'Utilities', 'Water', 100, 87.50, 'Variable', '2026-04-17'],
  ['April 2026', 'Debt / Loans', 'Credit Card Payment', 150, 350, 'Variable', '2026-04-09'],
  ['April 2026', 'Debt / Loans', 'Affirm', 100, 0, 'Fixed', '2026-04-17'],
  ['April 2026', 'Debt / Loans', 'Klarna', 100, 100.44, 'Fixed', '2026-04-17'],
  ['April 2026', 'Groceries', 'Groceries', 250, 68.22, 'Variable', '2026-04-30']
];

export const DAILY_CHORE_ROWS = `
Scoop Litterbox	Laundry Room	Daily
Feed Cats	Kitchen	Daily
Water Cats	Kitchen	Daily
Load / Empty Dishwasher	Kitchen	Daily
Wash Pots / Pans	Kitchen	Daily
Laundry Transfer	Laundry Room	Daily
Fold Clean Clean Clothes	Laundry Room	Daily
Dirty Clothes in Hamper	Master Bedroom	Daily
`;

export const CHORE_ROWS = `
Sweep Entryway	Front Entryway	Zone 1	Weekly	Monday
Mop Floor	Front Entryway	Zone 1	Monthly	Monday
Wipe Baseboards	Front Entryway	Zone 1	Monthly	Monday
Organize Shoes	Front Entryway	Zone 1	As Needed	Monday
Organize Jackets	Front Entryway	Zone 1	As Needed	Monday
Vacuum Floor	Live Room	Zone 1	Weekly	Monday
Pick Up Clutter	Live Room	Zone 1	Weekly	Monday
Clean Windows	Live Room	Zone 1	Monthly	Monday
Clean Stage Rug	Live Room	Zone 1	Monthly	Monday
Clean Set Props	Live Room	Zone 1	Monthly	Monday
Clean Windows	Live Room	Zone 1	Monthly	Monday
Organize Cables	Live Room	Zone 1	As Needed	Monday
Wash Green Screen	Live Room	Zone 1	As Needed	Monday
Clean Sink	Kitchen	Zone 2	Weekly	Tuesday
Clean Counters	Kitchen	Zone 2	Weekly	Tuesday
Get Rid of Old Food	Kitchen	Zone 2	Weekly	Tuesday
Clean Stove	Kitchen	Zone 2	Weekly	Tuesday
Organize Fridge	Kitchen	Zone 2	Weekly	Tuesday
Clean Microwave	Kitchen	Zone 2	Weekly	Tuesday
Sweep Floors	Kitchen	Zone 2	Weekly	Tuesday
Mop Floors	Kitchen	Zone 2	Weekly	Tuesday
Clean Coffee Maker	Kitchen	Zone 2	Weekly	Tuesday
Wipe Cabinets	Kitchen	Zone 2	Monthly	Tuesday
Clean Pantry	Kitchen	Zone 2	Monthly	Tuesday
Clean Oven	Kitchen	Zone 2	Monthly	Tuesday
Clean Fridge	Kitchen	Zone 2	Monthly	Tuesday
Wipe Baseboards	Kitchen	Zone 2	Monthly	Tuesday
Organize Pantry	Kitchen	Zone 2	Monthly	Tuesday
Clean Lazy Suzan	Kitchen	Zone 2	Monthly	Tuesday
Clean Cat Food Area	Rear Entryway	Zone 2	Weekly	Tuesday
Sweep Floors	Rear Entryway	Zone 2	Weekly	Tuesday
Mop Floors	Rear Entryway	Zone 2	Weekly	Tuesday
Clean Windows	Rear Entryway	Zone 2	Monthly	Tuesday
Clean Sliding Door	Rear Entryway	Zone 2	Monthly	Tuesday
Wipe Baseboards	Rear Entryway	Zone 2	Monthly	Tuesday
Change Litter Box	Laundry Room	Zone 2	Weekly	Tuesday
Clean Toilet	Laundry Room	Zone 2	Weekly	Tuesday
Wipe Down Washer / Dryer	Laundry Room	Zone 2	Weekly	Tuesday
Sweep Floor	Laundry Room	Zone 2	Weekly	Tuesday
Mop Floor	Laundry Room	Zone 2	Weekly	Tuesday
Clean Sink	Laundry Room	Zone 2	Weekly	Tuesday
Wipe Down Walls	Laundry Room	Zone 2	Monthly	Tuesday
Wipe Down Baseboards	Laundry Room	Zone 2	Monthly	Tuesday
Clean Mirror	Laundry Room	Zone 2	Monthly	Tuesday
Clean Window	Laundry Room	Zone 2	Monthly	Tuesday
Clear / Organize Surfaces	Control Room	Zone 3	Weekly	Wednesday
Dust Desk / Gear	Control Room	Zone 3	Weekly	Wednesday
Sweep Floor	Control Room	Zone 3	Weekly	Wednesday
Empty Trash	Control Room	Zone 3	Weekly	Wednesday
Clean Monitor	Control Room	Zone 3	Weekly	Wednesday
Organize Cables	Control Room	Zone 3	Weekly	Wednesday
Put Away Gear	Control Room	Zone 3	Weekly	Wednesday
Sweep Carpet	Stairs / Hallway	Zone 4	Weekly	Thursday
Wipe Baseboards	Stairs / Hallway	Zone 4	Monthly	Thursday
Clean Window	Stairs / Hallway	Zone 4	Monthly	Thursday
Sweep Carpet	Hall Closet	Zone 4	Monthly	Thursday
Organize Closet	Hall Closet	Zone 4	As Needed	Thursday
Sweep Carpet	Guest Bedroom	Zone 5	Monthly	Friday
Clean Windows	Guest Bedroom	Zone 5	Monthly	Friday
Wipe Baseboards	Guest Bedroom	Zone 5	Monthly	Friday
Organize Closet	Guest Bedroom	Zone 5	Monthly	Friday
Clean Curtains	Guest Bedroom	Zone 5	Quarterly	Friday
Wipe Sink	Guest Bathroom	Zone 5	Weekly	Friday
Clean Toilet	Guest Bathroom	Zone 5	Weekly	Friday
Sweep Floor	Guest Bathroom	Zone 5	Weekly	Friday
Mop Floor	Guest Bathroom	Zone 5	Weekly	Friday
Clean Mirror	Guest Bathroom	Zone 5	Monthly	Friday
Clean Shower	Guest Bathroom	Zone 5	Monthly	Friday
Clean Window	Guest Bathroom	Zone 5	Monthly	Friday
Wipe Baseboards	Guest Bathroom	Zone 5	Monthly	Friday
Organize Desk	Office	Zone 5	Weekly	Friday
Clean Desk	Office	Zone 5	Weekly	Friday
Wipe Monitors	Office	Zone 5	Weekly	Friday
Sweep Carpet	Office	Zone 5	Weekly	Friday
Clean Windows	Office	Zone 5	Monthly	Friday
Clean Shelves	Office	Zone 5	Monthly	Friday
Clean Couch	Office	Zone 5	Monthly	Friday
Wipe Baseboards	Office	Zone 5	Monthly	Friday
Clean Curtains	Office	Zone 5	Quarterly	Friday
Organize Books	Office	Zone 5	As Needed	Friday
Organize Shelves	Office	Zone 5	As Needed	Friday
Clean Nightstands	Master Bedroom	Zone 6	Weekly	Saturday
Sweep Carpet	Master Bedroom	Zone 6	Weekly	Saturday
Wipe Baseboard	Master Bedroom	Zone 6	Monthly	Saturday
Clean Windows	Master Bedroom	Zone 6	Monthly	Saturday
Wipe Closet Door	Master Bedroom	Zone 6	Monthly	Saturday
Clean Curtains	Master Bedroom	Zone 6	Quarterly	Saturday
Clean Sink / Counter	Master Bathroom	Zone 6	Weekly	Saturday
Clean Mirror	Master Bathroom	Zone 6	Weekly	Saturday
Clean Toilet	Master Bathroom	Zone 6	Weekly	Saturday
Clean Shower	Master Bathroom	Zone 6	Weekly	Saturday
Sweep Floor	Master Bathroom	Zone 6	Weekly	Saturday
Mop Floor	Master Bathroom	Zone 6	Weekly	Saturday
Wipe Baseboards	Master Bathroom	Zone 6	Monthly	Saturday
Clean Shower Door	Master Bathroom	Zone 6	Monthly	Saturday
Clean Window	Master Bathroom	Zone 6	Monthly	Saturday
Clean Curtains	Master Bathroom	Zone 6	Quarterly	Saturday
Organize Mirror Cabinet	Master Bathroom	Zone 6	As Needed	Saturday
Sweep Porch	Front Porch	Zone 7	Weekly	Sunday
Clean Windows	Front Porch	Zone 7	Monthly	Sunday
Clean Storm Door	Front Porch	Zone 7	Monthly	Sunday
Clean Chairs	Front Porch	Zone 7	Monthly	Sunday
Clean Table	Front Porch	Zone 7	Monthly	Sunday
Remove Boxes / Trash	Front Porch	Zone 7	As Needed	Sunday
Mow Lawn	Yard	Zone 7	Seasonal	Sunday
Weed Eat	Yard	Zone 7	Seasonal	Sunday
Trim Bushes	Yard	Zone 7	Seasonal	Sunday
Sweep Floors	Basement	Zone 7	Monthly	Sunday
Check Sump Pump	Basement	Zone 7	Monthly	Sunday
Check Foundation	Basement	Zone 7	Quarterly	Sunday
Organize	Basement	Zone 7	As Needed	Sunday
`;

export const PANTRY_ITEMS = [
  'All-purpose flour', 'Bread flour', 'Whole wheat flour', 'Cake flour', 'Cornmeal',
  'Baking powder', 'Baking soda', 'Active dry yeast', 'Vanilla extract', 'Cocoa powder',
  'Chocolate', 'Cornstarch', 'Panko breadcrumbs', 'Rollet oats', 'Polenta', 'Farro',
  'Barley', 'Bulgur', 'Wild rice', 'White rice', 'Jasmine rice', 'Arborio rice', 'Quinoa',
  'Couscous', 'Dried pasta', 'Dried beans', 'Lentils', 'Extra virgin olive oil',
  'Finishing olive oil', 'Truffle oil', 'Canola oil', 'Vegetable oil', 'Coconut oil',
  'Toasted sesame oil', 'Unsalted butter', 'Salted butter', 'Ghee', 'Duck fat',
  'White vinegar', 'Apple cider vinegar', 'Red wine vinegar', 'White wine vinegar',
  'Balsamic vinegar', 'Rice vinegar', 'Sherry vinegar', 'Lemons', 'Limes',
  'Granulated sugar', 'Light brown sugar', 'Dark brown sugar', 'Powdered sugar',
  'Honey', 'Maple syrup', 'Molasses', 'Kosher salt', 'Fine sea salt', 'Flaky salt',
  'Black pepper', 'Garlic powder', 'Onion powder', 'Smoked paprika', 'Sweet paprika',
  'Chili powder', 'Cayenne pepper', 'Red pepper flakes', 'Ground cumin',
  'Cround coriander', 'Ground cinnamon', 'Ground nutmeg', 'Ground ginger', 'Turmeric',
  'Whole cumin seeds', 'Fennel seeds', 'Coriander seeds', 'Cardamom pods', 'Cloves',
  'Star anise', 'Bay leaves', 'Black peppercorns', 'Oregano (dried)', 'Thyme (dried)',
  'Rosemary (dried)', 'Basil (dried)', 'Parsley (dried)', 'Dill (dried)',
  'Crushed tomatoes', 'Whole peeled tomatoes', 'Tomato paste', 'Tomato sauce',
  'Chicken stock', 'Beef stock', 'Vegetable stock', 'Soy sauce', 'Mirin', 'Curry paste',
  'Harissa', 'Tahini', 'Tamari', 'Fish sauce', 'Worcestershire sauce', 'Dijon mustard',
  'Whole grain mustard', 'Hot sauce', 'Chili paste', 'Miso paste', 'Oyster sauce',
  'Almonds', 'Walnuts', 'Pecans', 'Peanuts', 'Sesame seeds', 'Chia seeds', 'Flax seeds',
  'Raisins', 'Cranberries (dried)', 'Dates (dried)', 'Apricots (dried)'
];

export const HOUSEHOLD_SUPPLIES = [
  'Windex', 'Clorox Wipes', 'Dish Sponges', 'White Vinegar', 'Cat Litter'
];

export const GROCERY_ITEMS = [
  'Beef', 'Chicken', 'Ground Beef', 'Greek Yogurt', 'Honey', 'Shredded Mexican Cheese',
  'Unsalted Butter', 'Salted Butter', 'Eggs', 'Dish Sponges', 'CO2', 'Carbmaster buns',
  'Lowfat american cheese', 'Paper towels', 'Toilet paper', 'Soda stream syrup',
  'Coffee', 'Chocolate chips'
];
